class FFFooter {
	active = true
	oldWidth = window.innerWidth
  DOM: {
    footerAccordions: NodeListOf<HTMLElement>
  };
	
	constructor(){
		this.DOM = {
			footerAccordions: document.querySelectorAll('.siteFooter .js-accordionHeader'),
		};
		this.events();
	}

	events(){
    this.DOM.footerAccordions.forEach(el => {
      el.addEventListener( 'click', this.toggle.bind(this) )
    })
		window.addEventListener( 'optimizedResize', this.checkAccordion.bind(this) );
	}

	//remove accordion classes and styles when resizing up
	checkAccordion(){
		const newWidth = window.innerWidth;
		if( newWidth !== this.oldWidth && newWidth >= 768 && this.active ){
			this.active = false;
			this.collapseAll();
		}
		this.oldWidth = newWidth;
	}

	toggle(e: MouseEvent){
		e.preventDefault();
		const el = e.currentTarget;
    if( !(el instanceof HTMLElement )) return
		const wrap = el.parentNode?.querySelector( '.js-accordionContent' );
    if( !(wrap instanceof HTMLElement )) return
		const menu = wrap.querySelector( '.menu' );
    if( !(menu instanceof HTMLElement )) return
		const menuHeight = menu.clientHeight;
		
		if( el.classList.contains( 'active' ) ){
			this.active = false;
			el.classList.remove( 'active' );
			wrap.removeAttribute('style');
		}else{
			this.active = true;
			this.collapseAll();
			el.classList.add( 'active' );
			wrap.style.height = `${menuHeight}px`;
			wrap.style.opacity = "1";
		}
	}

	collapseAll(){
    this.DOM.footerAccordions.forEach( el => {
      const wrap = el.parentNode?.querySelector('.js-accordionContent');
			el.classList.remove('active');
			wrap?.removeAttribute('style');
    })
	}
};
new FFFooter();